import { BareButton } from '@calendly/ui/components/bare-button'
import styled from 'astroturf/react'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const textColor = 'var(--text-color, rgb(26, 26, 26))'
const fontSizeLabelSmall = 'var(--fontSizeLabelSmall, 0.6875rem)'
import { Icon } from '@calendly/ui/components/icon'

import { useI18n } from 'locales'
import _StyledBadge from "badge-StyledBadge.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/payment/stripe/badge.js?styleId=StyledBadge";
import _StyledIcon from "badge-StyledIcon.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/payment/stripe/badge.js?styleId=StyledIcon";


const StyledBadge = /*#__PURE__*/styled(BareButton, null, {
  displayName: "StyledBadge",
  styles: _StyledBadge,
  attrs: props => ({
    ...props,
    as: 'a'
  })
})

const StyledIcon = /*#__PURE__*/styled(Icon, null, {
  displayName: "StyledIcon",
  styles: _StyledIcon
})

const Badge = () => {
  const { i18n } = useI18n()
  return (
    <StyledBadge
      href="https://stripe.com"
      target="_blank"
      rel="noopener noreferrer"
    >
      {i18n.t('booking.invitee.powered_by')}
      <StyledIcon name="logo-stripe" />
    </StyledBadge>
  )
}

export default Badge
